const unionWith=(comparator,...args)=>{const union=[];return args.reduce((acc,curr)=>acc.concat(curr),[]).filter(el=>(union.some(x=>comparator(x,el))||union.push(el),!1)),union};export{unionWith};
